import React from 'react'
import PropTypes from 'prop-types'
import { PairButton, LeftButton, RightButton } from './PairButton.styled'
import NavButton from '../NavButton'

const PairNavButton = ({
  leftButton,
  leftButtonFunc,
  leftButtonLabel,
  isLeftButtonDisabled,
  isLeftBtnFocused,
  rightButton,
  rightButtonFunc,
  rightButtonLabel,
  isRightButtonDisabled,
  isModalBtn,
  isStopBtn,
}) => {
  return (
    <PairButton>
      <LeftButton>
        <NavButton
          onClickFunc={leftButtonFunc}
          content={leftButton}
          isModalBtn={isModalBtn}
          isStopBtn={isStopBtn}
          ariaLabel={leftButtonLabel}
          isDisabled={isLeftButtonDisabled}
          isBtnFocused={isLeftBtnFocused}
        ></NavButton>
      </LeftButton>
      <RightButton>
        <NavButton
          onClickFunc={rightButtonFunc}
          content={rightButton}
          ariaLabel={rightButtonLabel}
          isModalBtn={isModalBtn}
          isStopBtn={isStopBtn}
          isDisabled={isRightButtonDisabled}
        ></NavButton>
      </RightButton>
    </PairButton>
  )
}
PairNavButton.propTypes = {
  leftButton: PropTypes.string,
  leftButtonFuc: PropTypes.func,
  rightButton: PropTypes.string,
  rightButtonFuc: PropTypes.func,
}
export default PairNavButton
